/* eslint-disable react/prop-types */
import useGlobalClientCategories from '@hooks/fetching/useGlobalClientCategories';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomComponentInputs } from '../filters.types';

/**
 * Client category select wrapper for query filter system.
 * Loads the (small) list of client categories via the shared global hook and
 * lets the user pick one or more of them, returning an array of clientCategoryIds.
 */
export const ClientCategoryFilterSelect: React.FC<CustomComponentInputs> = ({ onChange, value }) => {
  const { t } = useTranslation();
  const { globalClientCategories } = useGlobalClientCategories();

  // Normalize value to always be an array for mode="multiple"
  const normalizedValue = useMemo(() => {
    if (!value) return undefined;
    if (Array.isArray(value)) {
      return value.map((v) => Number(v));
    }
    return [Number(value)];
  }, [value]);

  const options = useMemo(
    () => globalClientCategories.map((category) => ({ label: category.name, value: category.clientCategoryId })),
    [globalClientCategories]
  );

  const handleChange = (ids: number[]) => {
    onChange(ids && ids.length > 0 ? ids : null);
  };

  return (
    <Select
      allowClear
      mode="multiple"
      placeholder={t('filters-select-client-categories-placeholder')}
      maxTagCount="responsive"
      options={options}
      value={normalizedValue}
      onChange={handleChange}
      style={{ width: '100%', height: '44px' }}
      className="h-8"
    />
  );
};
